export var catalogs = {
  methods: {
    handleAsCatalog(dictionary) {
      return (
        this.comboField(dictionary) && !this.comboTagField(dictionary)
      );
    },
    findCatalogItem(dictionary, value, items) {
      let foundItem = null;
      if (this.handleAsCatalog(dictionary) && value != null) {
        items &&
          items.forEach((item) => {
            if (item.itemId == value.toString()) {
              foundItem = item;
            }
          });
      }
      return foundItem;
    },
    iconCatalogItem(dictionary, value, items) {
      let result = null;
      if (this.handleAsCatalog(dictionary) && value != null) {
        const item = this.findCatalogItem(dictionary, value, items);
        if (item) {
          result = {
            icon: item.itemIcon,
            color: item.itemColor,
            spreadColor: item.spreadColor
          };
        }
      }
      return result;
    },
    iconColorCatalogItem(dictionary, value, items) {
      const item = this.iconCatalogItem(dictionary, value, items);
      return item ? item.color : null;
    },
    
    spreadColorCatalogItem(dictionary, value, items) {
      const item = this.iconCatalogItem(dictionary, value, items);
      return item ? item.spreadColor : null;
    },

    getCatalogKey(dictionaryName, inputData) {
      let inputKey = "";
      if (inputData && Object.keys(inputData).length > 0) {
        Object.keys(inputData).forEach(inputField => {
          inputKey += inputField + ":" + inputData[inputField];
        })
      }
      return dictionaryName + inputKey;
    },


    findCatalogEx(screen, dictionaryName, inputData) {
      let result = null;
      const catalogsEx = screen.catalogsEx;
      catalogsEx.forEach(catalogEx => {
        const key = this.getCatalogKey(dictionaryName, inputData);
        if (catalogEx.key == key) {
          result = catalogEx;
        }
      });
      return result;
    },

    findCatalogExByKey(screen, key) {
      const catalogEx = screen ? screen.catalogsEx.find(catalogEx => {
        return catalogEx.key == key
      }) : null;
      return catalogEx;
    },

    findCatalogExList(screen, dictionaryName, inputData) {
      const catalogEx = this.findCatalogEx(screen, dictionaryName, inputData);
      return catalogEx ? catalogEx.items : [];
    },

    catalogFirst(dictionary) {
      return dictionary.catalogFirst == null || dictionary.catalogFirst == true;
    }
  }
}